import { ReactElement, forwardRef, Ref, MouseEvent } from "react";
import { sanitizeUriForReact } from "client_legacy/ndaw/urlHelper";
import { setTrackingId } from "../../Misc/utils";

type NativeReactAnchorProps = React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

export type AnchorProps = Omit<NativeReactAnchorProps, "rel" | "ref"> & { trackingId?: string; };

export const Anchor = forwardRef((props: AnchorProps, ref: Ref<HTMLAnchorElement>): ReactElement => {
	const {
		children,
		href,
		onClick,
		trackingId,
		...otherProps
	} = props;

	let sanitizedUri: string | undefined = sanitizeUriForReact(href)?.trim();
	let clickHandler: ((event: MouseEvent<HTMLAnchorElement>) => void) | undefined = onClick;

	const hasActualHref: boolean = Boolean(sanitizedUri);
	if (!hasActualHref) {
		sanitizedUri = "#none-existing";
		clickHandler = (args) => {
			args.preventDefault();
			if (onClick) {
				onClick(args);
			}
		};
	}

	return (
		<a
			{...otherProps}
			{...setTrackingId(trackingId)}
			rel="noopener noreferrer"
			href={sanitizedUri}
			ref={ref}
			onClick={clickHandler}
		>
			{children}
		</a>
	);
});
Anchor.displayName = "Anchor";
